import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export type StateList = NonNullable<FormsV1.Types.GetStatesV2IO['output']['states']>;

export const useGetStateList = (countryCode: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetStatesV2Query({
    request: {
      countryCode,
    },
    options: {
      enabled: !!countryCode,
      staleTime: Infinity, // never consider the data stale to avoid refetching
      cacheTime: Infinity, // never garbage collect the cached data
    },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  const stateList = data?.states ?? [];

  return { stateList, isLoading, isError };
};

export const useFetchStateList = () => {
  const fetchStates = FormsV1.Queries.useFetchGetStatesV2();

  return async (countryCode: string): Promise<StateList> => {
    const data = await fetchStates({
      request: { countryCode },
      options: { staleTime: Infinity },
      httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
      fallbackDataOnError: { states: [] },
    });
    return data?.states ?? [];
  };
};
